import React, { forwardRef, MouseEvent, useEffect, useState } from 'react';
import { Cell } from 'react-table';
import { IBindingCallback2 } from '../../common/models/callback';
import { Column } from '../../common/models/table/Column';
import Input from '../Input';
import styles from './styles.module.scss';

interface IProps {
  cell: Cell;
  editableRowIndex?: number;
  updateRowEditData: IBindingCallback2<string, any>;
  onClick: IBindingCallback2<Cell, React.MouseEvent<HTMLElement>>;
}

const DataCell = forwardRef<HTMLDivElement, IProps>(({
  cell,
  editableRowIndex,
  updateRowEditData,
  onClick
}, ref) => {
  const input = cell.value || '';
  const { editable, id: columnId, inputType } = cell.column as Column;
  const isEdit = editableRowIndex === cell.row.index && editable !== false;

  const [value, setValue] = useState<string>(input);

  useEffect(() => {
    setValue(input);
  }, [input]);

  useEffect(() => {
    if (!isEdit) setValue(input);
  }, [isEdit]);

  const onChange = (val: string) => {
    setValue(val);
  };

  const onBlur = () => updateRowEditData(columnId as string, value);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    onClick(cell, event);
  };

  return (
    <div
      ref={ref}
      className={`hr-table-td ${styles.td}`}
      {...cell.getCellProps()}
      role="presentation"
      onClick={handleClick}
    >
      {isEdit
        ? (
          <Input
            type={inputType}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            onClick={e => e.stopPropagation()}
            disableDropdown
          />
        )
        : cell.render('Cell')}
    </div>
  );
});

export default DataCell;
